import { Component, ViewEncapsulation } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
    selector: 'card-product-updated',
    templateUrl: './card-product-updated.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardProductUpdatedComponent extends CardComponent {}